var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('ul',_vm._l((_vm.breadCrumb),function(ref,index){
var name = ref.name;
var path = ref.path;
var label = ref.label; if ( label === void 0 ) label = null;
var params = ref.params; if ( params === void 0 ) params = {};
return _c('li',{key:index},[(index === _vm.breadCrumb.length - 1)?[_c('span',[_vm._v(_vm._s(label || _vm.$t(("breadcrumbs." + name), params)))])]:_c('nuxt-link',{attrs:{"to":path}},[_vm._v(_vm._s(label || _vm.$t(("breadcrumbs." + name), params)))])],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }